import React, { useState, useEffect } from 'react'

import {
  Row,
  Col,
  Steps,
  Form,
  Input,
  Select,
  DatePicker,
  Card,
  Upload,
  Button,
  Modal,
  Checkbox,
} from 'antd'
import styled from 'styled-components'
import { getCookie } from 'helper/cookie'
import {
  updateCheckList,
  saveCheckList,
  deleteCheckList,
  getResultCheckList,
  optionCheckList,
} from 'api/Project/checklist'

import lang from 'lang/en'

const initalState = {
  data: [],
  isLoading: true,
}

const CheckList = (props) => {
  const token = getCookie('access_token_admin')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const { idEditPRJ } = props
  const [form] = Form.useForm()

  ///lang
  const language = getCookie('lang')
  const word = lang[language]

  const [dataOptionChecklist, setDataOptionChecklist] = useState(initalState.data)

  const onFinish = (values) => {
    props.setModalVisionadd(false)
    if (values.addreqchecklist == '' || values.addreqchecklist == null) {
      values.addreqchecklist = 'N'
    } else {
      values.addreqchecklist = 'Y'
    }

    const dataArrayAddCheckList = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: props.id,
      title: values.addnamechecklist,
      checklist_type_id: values.addselectchecklist,
      required: values.addreqchecklist,
    }

    saveCheckList({
      params: dataArrayAddCheckList,
      token: token,
    }).then((response) => {
      if (response.status === 200) {
        props.getDataCheckList()
        form.setFieldsValue({
          addselectchecklist: null,
          addnamechecklist: null,
          addreqchecklist: null,
        })
      }
    })
  }

  //get option chceklist
  const getDataOptionCheckList = async () => {
    await optionCheckList({
      token: token,
    })
      .then(async (response) => {
        console.log(response)
        const { status, data, error } = response

        if (error) {
          await setDataOptionChecklist([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataOptionChecklist(data)
          await setIsLoading(false)
        } else {
          setDataOptionChecklist([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOptionChecklist([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (props.modalVisionadd) {
      getDataOptionCheckList()

      return () => {
        // getDataOptionCheckList()
      }
    }
  }, [props.modalVisionadd])

  const cancel = () => {
    props.setModalVisionadd(false)
    form.setFieldsValue({
      addselectchecklist: null,
      addnamechecklist: null,
      addreqchecklist: null,
    })
  }

  return (
    <Form form={form} name="SaveChecklist" onFinish={onFinish}>
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        className="checklistmodal"
        title={
          <h2 style={{ color: '#127EC3' }}>
            {word['addtask_information_btn_checklist_addnew']}
          </h2>
        }
        visible={props.modalVisionadd}
        onOk={form.submit}
        onCancel={cancel}
        okText="Save"
      >
        <h4>{word['addtask_information_title_modal_checklist_type']}</h4>
        <div style={{ paddingTop: 8 }}>
          <Form.Item
            name="addselectchecklist"
            rules={[
              {
                required: true,
                message: word['addtask_information_checklist_Type_Checklist'],
              },
            ]}
          >
            <Select
              id="addselectchecklist"
              placeholder="Type Checklist"
              style={{ width: 586 }}
              size="large"
            >
              {dataOptionChecklist.map((item) => (
                <Option value={item.id} dataselect={item}>
                  {item.name_en}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <h4 style={{ paddingTop: 24 }}>
          {word['addtask_information_title_modal_checklist_name']}
        </h4>
        <div style={{ paddingTop: 8 }}>
          <Form.Item
            name="addnamechecklist"
            rules={[
              {
                whitespace: true,
                required: true,
                message: word['addtask_information_checklist_Name_Checklist'],
              },
            ]}
          >
            <Input
              id="addnamechecklist"
              className="input"
              style={{ width: 586 }}
              placeholder="Name"
              size="large"
            ></Input>
          </Form.Item>
        </div>

        <div style={{ paddingTop: 24 }}>
          <Form.Item name="addreqchecklist">
            <Checkbox.Group>
              <Checkbox id="addreqchecklist" value="Y">
                {word['addtask_information_title_modal_checklist_required']}
              </Checkbox>
            </Checkbox.Group>
          </Form.Item>
        </div>
      </Modal>
    </Form>
  )
}
export default CheckList
